import { baseServiceRequest } from "@apis/baseServiceRequest"
import type { ISlackUsernames, IToken, IUser } from "./types"

export const getUserByEmail = async (email: string): Promise<IUser> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/users?email=${email}`,
  })
  return response.data
}

export const getToken = async (token: string): Promise<IToken> => {
  const response = await baseServiceRequest({
    method: "POST",
    url: `/tokens`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const getSlackUsernames = async (): Promise<ISlackUsernames> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: "users/slack_usernames",
  })
  return response.data
}
